import {
  Button,
  Col,
  Descriptions,
  Form,
  Input,
  Modal,
  Row,
  Select,
  Space,
  Switch,
  Table,
} from "antd";
import React, { useState, useEffect, useRef, useCallback } from "react";
import { FcInfo } from "react-icons/fc";

import Layout from "../../../components/Layout";
import { request } from "../../../config/API";
import {
  ReloadOutlined,
  PlusOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import authHeader from "../../../redux/services/authHeader";
import { COLORS } from "../../../config/theme";
import styles from "./TeamCollab.module.css";
import { openNotification } from "../../../redux/actions/Notification/notifications.action";
import { useDebouncedCallback } from "use-debounce";
import moment from "moment";
import {
  ACTING_ADMIN,
  EDITOR_ADMIN,
  VIWEER_ADMIN,
  WHITE_LABEL_ADMIN,
} from "../../../config/roles";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { updateTourState } from "../../../redux/actions/Admin/admin.actions";
const { Option } = Select;
const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 },
};
const tailLayout = {
  wrapperCol: { offset: 8, span: 16 },
};
const TeamCollab = () => {
  const dispatch = useDispatch();
  const { tourActive } = useSelector((state) => state.user);

  const { primaryDark, primary } = COLORS;
  const [teamCollabList, setTeamCollabList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [infoModal, setInfoModal] = useState(!tourActive);

  // pagination
  const [count, setCount] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  function handlePageChange(current) {
    setCurrentPage(current);
  }
  function handleSizeChange(a, b, c) {
    setCurrentPage(a);
    setPageSize(b);
  }

  const getTeamCollabList = () => {
    setIsLoading(true);
    request
      .get("user/team-collab", {
        params: { pageSize, pageNumber: currentPage },
        headers: { ...authHeader() },
      })
      .then(({ data: { data } }) => {
        setTeamCollabList(data?.teamCollabs);
        setCount(data?.count);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log("err =>", err.response);
        const error = err?.response?.data || "Something Happened";
        openNotification({
          message: "Error",
          description: error,
          icon: "error",
        });
        setIsLoading(false);
      });
  };
  useEffect(getTeamCollabList, [currentPage, pageSize]);

  const columns = [
    {
      title: "Full Name",
      dataIndex: "fullName",
      key: "fullName",
      className: styles.antRow,
      ellipsis: true,
      //   width: "20%",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      className: styles.antRow,
      ellipsis: true,
      //   width: "15%",
    },
    {
      width: "15%",
      title: "Invited By",
      dataIndex: ["createdBy", "fullName"],
      key: "createdBy",
    },
    {
      title: "Permission",
      dataIndex: "role",
      key: "role",
      className: styles.antRow,
      //   width: "10%",
      render: (row, entry) => {
        return (
          <p>
            {entry.role === ACTING_ADMIN
              ? "Full Access"
              : entry.role === EDITOR_ADMIN
              ? "Edit Access"
              : entry.role === WHITE_LABEL_ADMIN
              ? "White Label"
              : "View Access"}
          </p>
        );
      },
    },
    {
      title: "Actions",
      key: "actions",
      render: (text) => {
        return (
          <Space>
            <Button
              id="change_team_collab_permission"
              size="middle"
              shape="round"
              onClick={() => {
                setSelectedUser(text);
                setEditPermissionLevelModal(true);
              }}
            >
              Change Permission
            </Button>
            <Button
              size="middle"
              shape="round"
              onClick={() => {
                setSelectedUser(text);
                setIsChangePassVisible(true);
              }}
            >
              Change Password
            </Button>
          </Space>
        );
      },
    },
    {
      width: "10%",
      title: "Status",
      key: "status",
      render: (text) => {
        return (
          <>
            <Switch
              style={{
                background: text?.status === "active" ? "#55B659" : "#FF6461",
              }}
              checkedChildren={"ACTIVE"}
              unCheckedChildren={
                !text?.status || text?.status === "pending"
                  ? "PENDING"
                  : "INACTIVE"
              }
              checked={text?.status === "active" ? true : false}
              onChange={() => {
                request
                  .put(
                    `user/change-team-collab-status/${text._id}`,
                    {},
                    { headers: { ...authHeader() } }
                  )
                  .then(() => {
                    setIsDeleteing(false);
                    setDeleteAdminData({});
                    openNotification({
                      message: "Success!",
                      description: "Collabrator Status Successfully!",
                      icon: "success",
                    });

                    setIsDeleteModalVisible(false);
                    getTeamCollabList();
                  })
                  .catch((err) => {
                    setIsDeleteing(false);
                    const error =
                      err?.response?.message ||
                      err?.response?.statusText ||
                      "Something Happened";
                    openNotification({
                      message: "Error",
                      description: error,
                      icon: "error",
                    });
                  });
              }}
            />
          </>
        );
      },
    },
    {
      width: "15%",
      title: "Joining Date",
      dataIndex: "joiningDate",
      key: "joiningDate",
      render: (text) => (
        <p style={{ fontWeight: "400", fontSize: "1.15rem" }}>
          {text ? moment(new Date(text)).format("D/MM/YYYY") : ""}
        </p>
      ),
    },
  ];

  const [form] = Form.useForm();
  const formRef = useRef(null);
  const [form2] = Form.useForm();
  const [form3] = Form.useForm();
  const form3Ref = useRef(null);
  const [form4] = Form.useForm();

  // edit qrAllowed Modal
  const [editPermissionLevel, setEditPermissionLevelModal] = useState(false);
  const [isEditting, setIsEditting] = useState(false);

  const handleEditPermissionLevel = (values) => {
    setIsEditting(true);
    request
      .put(
        `user/change-permission-team-collab/${selectedUser?._id}`,
        { role: values.role },
        { headers: { ...authHeader() } }
      )
      .then(() => {
        setIsEditting(false);
        form3.resetFields();
        setEditPermissionLevelModal(false);
        openNotification({
          message: "Success",
          description: "Permission Level Changed",
          icon: "success",
        });
        getTeamCollabList();
      })
      .catch((err) => {
        const error = err?.response?.data?.data || "Something Happened";
        openNotification({
          message: "Error",
          description: error,
          icon: "error",
        });
        setIsEditting(false);
        // setEditPermissionLevelModal(false);
      });
  };
  //Add New Team Collab
  const [addTemCollabModal, setAddTemCollabModal] = useState(false);
  const [isAdding, setIsAdding] = useState(false);
  const [selectedPermission, setSelectedPermission] = useState("");
  const onPermissionChange = (value, formref) => {
    switch (value) {
      case ACTING_ADMIN:
        formref.current.setFieldsValue({ role: ACTING_ADMIN });
        setSelectedPermission(ACTING_ADMIN);
        return;
      case EDITOR_ADMIN:
        formref.current.setFieldsValue({ role: EDITOR_ADMIN });
        setSelectedPermission(EDITOR_ADMIN);

        return;
      case VIWEER_ADMIN:
        formref.current.setFieldsValue({ role: VIWEER_ADMIN });
        setSelectedPermission(VIWEER_ADMIN);
        return;
      case WHITE_LABEL_ADMIN:
        formref.current.setFieldsValue({ role: WHITE_LABEL_ADMIN });
        setSelectedPermission(WHITE_LABEL_ADMIN);
        return;
      default:
        setSelectedPermission("");

        break;
    }
  };
  const handleAddTeamCollabrator = (values) => {
    setIsAdding(true);
    request
      .post(`user/add-team-collab`, values, { headers: { ...authHeader() } })
      .then(() => {
        setIsAdding(false);
        setAddTemCollabModal(false);
        openNotification({
          message: "Success!",
          description: "Admin Added Successfully!",
          icon: "success",
        });

        setIsDeleteModalVisible(false);
        getTeamCollabList();
      })
      .catch((err) => {
        setIsAdding(false);
        const error =
          err?.response?.data.data ||
          err?.response?.data.message ||
          "Something Happened";
        openNotification({
          message: "Error",
          description: error,
          icon: "error",
        });
      });
  };
  // Change Password Modal
  const [isChangePassVisible, setIsChangePassVisible] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [isPassChanging, setIsPassChanging] = useState(false);

  const handlePasswordChange = (values) => {
    const data = { ...values, id: selectedUser?._id };
    setIsPassChanging(true);
    request
      .post(`user/change-password-team-collab`, data, {
        headers: { ...authHeader() },
      })
      .then(() => {
        setIsPassChanging(false);
        setIsChangePassVisible(false);
        setSelectedUser({});
        form2.resetFields();
        openNotification({
          message: "Success!",
          description: "Password Updated Successfully",
          icon: "success",
        });
      })
      .catch((err) => {
        setIsPassChanging(false);
        const error =
          err?.response?.data.data ||
          err?.response?.data.message ||
          "Something Happened";
        openNotification({
          message: "Error",
          description: error,
          icon: "error",
        });
      });
  };

  // Delete Admin
  const [deleteAdminData, setDeleteAdminData] = useState({});
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [isDeleteing, setIsDeleteing] = useState(false);
  const handleDeleteTeamCollab = (data) => {
    const { id, password } = data;
    setIsDeleteing(true);
    request
      .put(
        `user/delete-team-collab/${id}`,
        { password },
        { headers: { ...authHeader() } }
      )
      .then(() => {
        setIsDeleteing(false);
        setDeleteAdminData({});
        openNotification({
          message: "Success!",
          description: "Collabrator Deleted Successfully!",
          icon: "success",
        });

        setIsDeleteModalVisible(false);
        getTeamCollabList();
      })
      .catch((err) => {
        setIsDeleteing(false);
        const error =
          err?.response?.message ||
          err?.response?.statusText ||
          "Something Happened";
        openNotification({
          message: "Error",
          description: error,
          icon: "error",
        });
      });
  };

  // Searching
  const [searchedData, setSearchedData] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const [searchvalue, setSearchValue] = useState("");
  const [searchStatus, setSearchStatus] = useState("undecided");
  const onSearch = () => {
    setIsSearching(true);
    request
      .post(
        "/user/admin/search",
        { query: searchvalue },
        { headers: { ...authHeader() } }
      )
      .then(({ data: { data } }) => {
        setSearchedData(data);
        setIsSearching(false);
        setSearchStatus("success");
      })
      .catch((e) => {
        console.log("🚀 ~ file: QRCodes.jsx ~ line 142 ~ onSearch ~ e", e);
        setIsSearching(false);
        setSearchStatus("error");
      });
  };
  useEffect(() => {
    if (searchvalue === "") {
      setSearchedData([]);
      setSearchStatus("undecided");
    }
  }, [searchvalue]);
  const debounced = useDebouncedCallback(() => {
    onSearch();
  }, 500);
  useEffect(() => {
    if (!searchvalue) return;
    debounced(searchvalue);
  }, [debounced, searchvalue]);
  //////////////////////////

  const tourCountinue = useCallback(() => {
    if (tourActive) {
      setTimeout(() => {
        if (teamCollabList.length === 0) {
          setTeamCollabList([
            {
              _id: "123123",
              fullName: "Member 1",
              email: "member@email.com",
              createdBy: "you@email.com",
              role: "actingadmin",
              status: "active",
              updatedAt: "2022-09-29T06:37:07.430Z",
            },
          ]);
        }
        dispatch(updateTourState(true, null, true)); //run, stepIndex, tourActive
      }, 1500);
    }
  }, [dispatch, tourActive, teamCollabList.length]);
  useEffect(() => {
    tourCountinue();
  }, [tourCountinue]);
  return (
    <Layout heading="Admins" hasBadge stat={count}>
      <Space style={{ marginBottom: 24, float: "right" }} wrap={true}>
        <Form
          onFinish={() => {
            if (searchvalue === "") {
              alert("Please enter some value!");
            } else {
              onSearch();
            }
          }}
          onFinishFailed={(x) => {
            console.log(x);
          }}
          style={{ display: "flex" }}
        >
          <Form.Item
            name="search"
            // label="Search"
            style={{ margin: 0 }}
          >
            <Input
              style={{ borderTopLeftRadius: 50, borderBottomLeftRadius: 50 }}
              allowClear
              value={searchvalue}
              onChange={(e) => {
                setSearchValue(e.target.value);
              }}
              placeholder="Search ..."
            />
          </Form.Item>
          <Form.Item style={{ margin: 0 }}>
            <Button
              type="primary"
              style={{
                width: 50,
                background: primaryDark,
                borderTopRightRadius: 50,
                borderBottomRightRadius: 50,
                border: "none",
                paddingLeft: 10,
                paddingRight: 10,
              }}
              htmlType="submit"
              loading={isSearching}
              icon={<SearchOutlined />}
            />
          </Form.Item>
        </Form>
        <Button
          id="add_team_collab_button"
          shape="round"
          type="primary"
          style={{ background: primaryDark, borderColor: primaryDark }}
          onClick={() => {
            setAddTemCollabModal(true);
          }}
          icon={<PlusOutlined />}
        >
          Add Team
        </Button>
        <Button
          shape="round"
          type="primary"
          style={{ background: primaryDark, borderColor: primaryDark }}
          onClick={getTeamCollabList}
          icon={<ReloadOutlined />}
        >
          Refresh
        </Button>
      </Space>
      {searchStatus === "success" ? (
        <Table
          size="large"
          dataSource={searchedData?.users}
          rowKey={({ _id }) => _id}
          columns={columns}
          pagination={{
            hideOnSinglePage: false,
            showTotal: (total, range) =>
              `${range[0]}-${range[1]} of ${total} items`,
          }}
        />
      ) : (
        <Table
          size="large"
          dataSource={teamCollabList}
          rowKey={({ _id }) => _id}
          columns={columns}
          loading={isLoading}
          pagination={{
            hideOnSinglePage: true,
            pageSize: pageSize,
            current: currentPage,
            total: count,
            showTotal: (total, range) =>
              `${range[0]}-${range[1]} of ${total} items`,
            // showTotal: (total) => `Total ${total} items`,
            onChange: handlePageChange,
            showSizeChanger: true,
            onShowSizeChange: handleSizeChange,
          }}
        />
      )}

      {/* Add Team Collab Modal */}
      <Modal
        visible={addTemCollabModal}
        title="Add New Team Collabrator"
        footer={null}
        onCancel={() => {
          setAddTemCollabModal(false);
          form.resetFields();
        }}
      >
        <Form
          {...layout}
          form={form}
          ref={formRef}
          labelAlign="left"
          onFinish={handleAddTeamCollabrator}
        >
          <Form.Item
            label="Enter Full Name"
            name="fullName"
            hasFeedback
            rules={[{ required: true, message: "This field is required" }]}
          >
            <Input size="large" />
          </Form.Item>
          <Form.Item
            label="Email"
            name="email"
            hasFeedback
            rules={[
              { required: true, message: "This field is required" },
              { type: "email", message: "Please Enter Valid Email" },
            ]}
          >
            <Input size="large" />
          </Form.Item>
          <Form.Item
            name="role"
            label="Permission"
            rules={[{ required: true }]}
          >
            <Select
              placeholder="Select Permission Level"
              onChange={(value) => onPermissionChange(value, formRef)}
              allowClear
            >
              <Option value={ACTING_ADMIN}>Admin</Option>
              <Option value={EDITOR_ADMIN}>Editor</Option>
              <Option value={VIWEER_ADMIN}>Viewer</Option>
              <Option value={WHITE_LABEL_ADMIN}>White Label</Option>
            </Select>
          </Form.Item>
          {selectedPermission === WHITE_LABEL_ADMIN && (
            <>
              <Form.Item
                labelAlign="left"
                label="Password"
                name="password"
                hasFeedback
                rules={[
                  { required: true, message: "This field is required" },
                  {
                    min: 6,
                    message: "Password should be atleast 6 characters",
                  },
                ]}
              >
                <Input.Password size="large" style={{ borderRadius: 8 }} />
              </Form.Item>
              <Form.Item
                labelAlign="left"
                label="Re-Password"
                name="confirmPassword"
                hasFeedback
                dependencies={["password"]}
                rules={[
                  { required: true, message: "This field is required" },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue("password") === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(
                        new Error(
                          "The two passwords that you entered do not match!"
                        )
                      );
                    },
                  }),
                ]}
              >
                <Input.Password size="large" style={{ borderRadius: 8 }} />
              </Form.Item>
            </>
          )}
          <Form.Item {...tailLayout}>
            <Button
              type="primary"
              shape="round"
              style={{
                display: "flex",
                background: primaryDark,
                borderColor: primaryDark,
                alignSelf: "center",
                paddingLeft: "4rem",
                paddingRight: "4rem",
              }}
              size="large"
              htmlType="submit"
              loading={isAdding}
            >
              Add
            </Button>
          </Form.Item>
        </Form>
      </Modal>
      {/* Change Password Modal */}
      <Modal
        visible={isChangePassVisible}
        title="Change Password"
        footer={null}
        onCancel={() => {
          setIsChangePassVisible(false);
          setSelectedUser(null);
          form2.resetFields();
        }}
      >
        <Form form={form2} onFinish={handlePasswordChange}>
          <Form.Item
            labelCol={{ span: 7 }}
            labelAlign="left"
            label="Password"
            name="password"
            hasFeedback
            rules={[
              { required: true, message: "This field is required" },
              { min: 6, message: "Password should be atleast 6 characters" },
            ]}
          >
            <Input.Password size="large" style={{ borderRadius: 8 }} />
          </Form.Item>
          <Form.Item
            labelCol={{ span: 7 }}
            labelAlign="left"
            label="Re-Password"
            name="confirmPassword"
            hasFeedback
            dependencies={["password"]}
            rules={[
              { required: true, message: "This field is required" },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("password") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(
                    new Error(
                      "The two passwords that you entered do not match!"
                    )
                  );
                },
              }),
            ]}
          >
            <Input.Password size="large" style={{ borderRadius: 8 }} />
          </Form.Item>
          <Form.Item style={{ marginBottom: 0, textAlign: "right" }}>
            <Button
              loading={isPassChanging}
              type="primary"
              shape="round"
              style={{ background: primaryDark, borderColor: primaryDark }}
              size="large"
              htmlType="submit"
            >
              Submit
            </Button>
          </Form.Item>
        </Form>
      </Modal>
      {/* Change Permission Modal */}
      <Modal
        visible={editPermissionLevel}
        title="Change Permission Level"
        onCancel={() => {
          setEditPermissionLevelModal(false);
          form3.resetFields();
        }}
        centered
        footer={null}
      >
        <Form
          {...layout}
          form={form3}
          ref={form3Ref}
          labelAlign="left"
          onFinish={handleEditPermissionLevel}
        >
          <Form.Item
            name="role"
            label="Permission"
            rules={[{ required: true }]}
          >
            <Select
              placeholder="Select Permission Level"
              onChange={(value) => onPermissionChange(value, form3Ref)}
              allowClear
            >
              <Option value={ACTING_ADMIN}>Admin</Option>
              <Option value={EDITOR_ADMIN}>Editor</Option>
              <Option value={VIWEER_ADMIN}>Viewer</Option>
              <Option value={WHITE_LABEL_ADMIN}>White Label</Option>
            </Select>
          </Form.Item>
          <Form.Item {...tailLayout}>
            <Button
              type="primary"
              shape="round"
              style={{
                display: "flex",
                background: primaryDark,
                borderColor: primaryDark,
                alignSelf: "center",
                paddingLeft: "4rem",
                paddingRight: "4rem",
              }}
              size="large"
              htmlType="submit"
              loading={isEditting}
            >
              Change
            </Button>
          </Form.Item>
        </Form>
      </Modal>
      {/* Delete Admin Modal */}
      <Modal
        visible={isDeleteModalVisible}
        title="Delete Admin"
        onCancel={() => {
          setIsDeleteModalVisible(false);
          setDeleteAdminData({});
          form4.resetFields();
        }}
        width={650}
        centered
        footer={null}
      >
        <Form
          name="deleteAdmin"
          form={form4}
          onFinish={(e) =>
            handleDeleteTeamCollab({ ...e, id: deleteAdminData?._id })
          }
          onFinishFailed={(err) => console.error(err)}
        >
          <Descriptions layout="horizontal" bordered column={2} size="middle">
            <Descriptions.Item label="Name" span={24}>
              {deleteAdminData?.fullName}
            </Descriptions.Item>
            <Descriptions.Item label="Email" span={24}>
              {deleteAdminData?.email}
            </Descriptions.Item>
            <Descriptions.Item label="Permission">
              {deleteAdminData?.role === "actingadmin"
                ? "Full Access"
                : deleteAdminData.role === "editoradmin"
                ? "Edit Access"
                : "View Access"}
            </Descriptions.Item>
          </Descriptions>

          <Form.Item
            label="Enter Password to verify"
            name="password"
            style={{ marginTop: 24 }}
            required
            rules={[{ required: true, message: "This field is required" }]}
          >
            <Input.Password style={{ borderRadius: 8 }} size="large" />
          </Form.Item>

          <Form.Item style={{ marginBottom: 0, textAlign: "right" }}>
            <Button
              loading={isDeleteing}
              type="primary"
              shape="round"
              style={{ background: primaryDark, borderColor: primaryDark }}
              size="large"
              htmlType="submit"
            >
              Delete
            </Button>
          </Form.Item>
        </Form>
      </Modal>
      {/* Info Modal */}
      <Modal
        visible={infoModal}
        footer={null}
        closable={false}
        centered
        width="50rem"
        bodyStyle={{
          padding: "3rem",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Col>
          <FcInfo
            style={{
              height: "5rem",
              width: "100%",
              alignSelf: "center",
              marginBottom: "2rem",
            }}
          />
          <Row>
            <span
              style={{
                fontSize: "1.1rem",
                fontWeight: "500",
                marginBottom: "1.3rem",
                textAlign: "justify",
              }}
            >
              The team collaboration page is for inviting portal admins only. To
              assign or transfer Wave Cards to any team member, please click on
              the assign card button on the Wave Cards page next to each card!
            </span>
          </Row>
          <Row
            style={{
              width: "100%",
              alignContent: "space-evenly",
              justifyContent: "space-evenly",
            }}
            span={8}
          >
            <Button
              shape="round"
              type="primary"
              style={{
                background: primary,
                borderColor: primary,
                width: "6rem",
              }}
              onClick={() => {
                setInfoModal(false);
              }}
            >
              Okay
            </Button>
          </Row>
        </Col>
      </Modal>
    </Layout>
  );
};

export default TeamCollab;
